import axios from "axios";
import router from "./router";

//let baseUrl = "https://flexi-comms-api.simplesoftware.nz/";
let baseUrl = "https://api.flexi-comms.com";
let host = window.location.host;
if (
  host == "localhost:8080" ||
  host == "localhost:8081" ||
  host == "localhost:8082"
) {
  baseUrl = "http://localhost:32775";
  baseUrl = "https://api.flexi-comms.com";
} else if (host.substring(0, 4) == "dev.") {
  baseUrl = "https://flexi-comms-api.simplesoftware.nz";
} else if (host == "10.0.0.141:8080") {
  baseUrl = "http://10.0.0.141:32775";
} else if (host == "flexicomms.local") {
  baseUrl = "http://flexicomms.local:32775";
}

let api = axios.create({
  baseURL: baseUrl,
  withCredentials: true
});

// Add a response interceptor
api.interceptors.response.use(
  function(response) {
    // if (
    //   response.data.hasOwnProperty("Result") &&
    //   response.data.Result == "No Internet"
    // ) {
    //   if (
    //     !router.currentRoute.meta.offlineAvailability &&
    //     router.currentRoute.name != null
    //   ) {
    //     router.push("/mobile-view/home");
    //   }
    // }
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default api;
